import clsx from "clsx";

const baseCard = clsx("h-[420px] w-[300px] bg-white shadow-md rounded-lg border-2 border-black/10 text-black/40")
export const centerCard = clsx(baseCard + " z-10 p-10 text-6xl text-black/30")
export const linkText = clsx("mt-4 text-green py-2 text-center text-sm font-bold uppercase tracking-wide hover:text-green/80")
export const leftCard = clsx(baseCard + " -mr-60 -rotate-6 ")
export const rightCard = clsx(baseCard + " -ml-60 rotate-6")